import { ChangeDetectionStrategy, HostListener, ElementRef, AfterViewInit, Component, ViewChild, OnInit, Input, SimpleChanges, OnChanges, Output, EventEmitter, ViewChildren, Inject, ChangeDetectorRef, OnDestroy, Injector, Renderer2 } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { PageService } from 'src/app/bloom/services/page-service.service';
import { MetaService } from 'src/app/bloom/services/meta-service';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { BoxService } from 'src/app/bloom/services/box-service.service'
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from 'src/app/shared/snackbar/snackbar.component';
import { WidgetManager } from 'src/app/bloom/models/WidgetManager';
import { WIDGET_OPTIONS, WidgetUtilityService } from 'src/app/bloom/services/widget-utility.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ListPanelService } from '../list-panel.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { ApplicationAction } from 'src/app/bloom/models/Action/ApplicationAction';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { AutomationService } from 'src/app/bloom/services/automation.service';
import { PopupEditViewComponent } from 'src/app/shared/popup-edit-view/popup-edit-view.component';
import { TemplateEngine } from 'src/app/core/common/TemplateEngine';
import { SkeletonElement } from 'src/app/shared/spinner/skeleton/skeleton.component';
import { DeleteDialogComponent } from 'src/app/shared/delete-dialog/delete-dialog.component';
import { ResourceDeletionService } from 'src/app/shared/services/resource-deletion.service';
import { WidgetService } from 'src/app/bloom/services/widget-service.service';
import { Subject, takeUntil } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConnectionService } from 'src/app/modules/organization/connection.service';
import { TokenUtil } from 'src/app/core/services/TokenUtil.service';
import { WidgetMetaTransformationService } from 'src/app/bloom/services/widget-meta-transformation.service';

@Component({
    selector: 'app-data-table',
    templateUrl: './data-table.component.html',
    styleUrls: ['./data-table.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DataTableComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  DEFAULT_IMAGE_SIZE: number = 5
  MAX_IMAGE_SIZE: number = 20
  MIN_IMAGE_SIZE: number = 4
  imageResizeStep: number = 1

  widgetContextMenuActions: any = {}

  @Input() panelMeta: any;
  @Input() processedData: any;
  @Input() displayedColumns: any = ['loading'];   //give a default value and wait for input
  @Input() totalCount: any = 0
  @Input() pageSize: any = 5
  @Input() pageNumber: any = 1
  @Input() runSpinner: any = false
  // @Input() loadingData: any = false
  @Input() error: any;
  @Input() builderMode: any;
  @Input() viewType: any;
  @Input() rawBoxData: any;
  @Input() availableAttributes:any;
  @Output() raisePageEvent = new EventEmitter()
  @Output() metaChange = new EventEmitter()

  @Output() subPanel = new EventEmitter()
  @Output() columnSelectionChanged = new EventEmitter();
  @Output() customOrderChanged = new EventEmitter();
  @Output() selectedRowData = new EventEmitter();
  @Output() checkboxSelected = new EventEmitter();
  @Output() rowDeletion = new EventEmitter();
  @Output() refreshData = new EventEmitter();

  @Input() isSubPanel: boolean;
  @Input() isInputData:boolean;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatTable) table!: MatTable<any>;
  @ViewChildren('cell') cells;
  @ViewChildren('dataCard') dataCard;
  @ViewChildren('imageWidgetWrap') imageWidgetWrap;

  selectedAttributes:any = []//new FormControl('');
  // skeletonSpinnerGridMap: SkeletonElement[] = []
  dataSource: any = [];
  dataLength: any = 0;
  gotResponse: boolean = false
  defaultPageSize: number = 5
  defaultPageNumber: number = 1;
  dataBindConfigResult: any;

  tableData: any = undefined;
  selectedRows = {};
  widgetMetaMap: any
  attributeIds: string[] = []
  columnData: any[] = []
  previousWidths: any[] = [];
  // Column resize properties
  columnWidths: { [key: string]: string } = {};
  private resizing = false;
  private currentColumn = -1;
  private startX = 0;
  private startWidth = 0;
  colWidth: number;
  navMap: any = {};
  bloomCode: string;
  pageCode: string;
  isFragment: boolean = false;
  fragment: string;
  errorOccurred: boolean = false;
  ready: boolean = false;

  groupValues: string[] = []
  groupedData = {
    groupValues: this.groupValues
  }
  currentViewType: string
  newViewType: string
  maxImageHeight: number
  widgetOptions: WIDGET_OPTIONS = {
    dragDrop: false,
    textEdit: false,
    deleteEnabled: false,
    configurationEnabled: true,
    widgetSelectionEnabled: false,
    cardImage: true
  }
  contextChangedSub:any
  prevContextWidgetId:any
  @ViewChild('menuTrigger') contextMenuTrigger: MatMenuTrigger

  mouseOverFullText: string = ""
  isBrowser: any;
  screenWidth: number;
  getPageMetaSubscription: any
  // pageMeta: any

  cardSizeMap: any = {
    xs: { large: "75", medium: "40", small: "40"}, // 0 - 600
    sm: { large: "40", medium: "30", small: "20"}, // 600 - 900
    md: { large: "30", medium: "28", small: "20"}, // 900 - 1200
    lg: { large: "23", medium: "15", small: "10"}, // 1200 - 1536
    xl: { large: "15", medium: "10", small: "8"}, // > 1536
  }


  /**
   * queue of records deleted locally, waiting for success response from server
   */
  inProgressDeletedRecords: any[] = []
  deletionProgressRecordMap: any = {}

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  // displayedColumns = ["loading"];
  supportedWidgets: any = ['link', 'icon', 'datetime', 'date', 'tags', 'button', 'image', 'autocomplete', 'select', 'chips', 'input', "numberinput"];
  private destroy$ = new Subject<void>();
  listAttributes: any = [];

  @ViewChild('pillarWrapRef') pillarWrapRef!: ElementRef;

  inputParams: {};
  valueTimers: any = {};
  constructor(
    private metaService: MetaService,
    public pageService: PageService,
    private route: ActivatedRoute,
    private router: Router,
    private boxService: BoxService,
    private _snackBar: MatSnackBar,
    public connectionService: ConnectionService,
    public tokenUtil: TokenUtil,
    public dialog: MatDialog,
    public listPanelService: ListPanelService,
    // public applicationAction: ApplicationAction, // Commented out to resolve circular dependency
    public automationService: AutomationService,
    private resourceDeletionService: ResourceDeletionService,
    private cdr: ChangeDetectorRef,
    private widgetService: WidgetService,
    private injector: Injector, // Added injector to get ApplicationAction when needed
    private wmtService: WidgetMetaTransformationService,
    private renderer2: Renderer2,
    @Inject(PLATFORM_ID) platformId?: Object,
    ) {
      this.isBrowser = isPlatformBrowser(platformId);
      if(!this.isBrowser) return;
    }

  // Method to get ApplicationAction service only when needed
  private getApplicationAction(): ApplicationAction {
    return this.injector.get(ApplicationAction);
  }

  raiseContextMenuActions(event, rowIndex, attrId){
    // console.log("event", event, "rowIndex", rowIndex, "attrId", attrId)
    if(!this.widgetContextMenuActions[rowIndex]) this.widgetContextMenuActions[rowIndex] = {}
    this.widgetContextMenuActions[rowIndex][attrId] = event;
    // console.log("raiseContextMenuActions[rowIndex][attrId]", this.widgetContextMenuActions[rowIndex][attrId])
    // console.log("raiseContextMenuActions", this.widgetContextMenuActions)
  }


  ngOnChanges(changes: SimpleChanges) {
    console.log("[DATA TABLE] ngOnChanges() changes", changes);
    if(changes.rawBoxData && changes.rawBoxData.currentValue){
      console.log("rawBoxData received in dataTable", this.rawBoxData)
    }

    if(changes.processedData && changes.processedData.currentValue){
      this.processedDataChanged(changes.processedData.currentValue)
    }
    if(changes.error && changes.error.currentValue){
      this.errorOccurred = true
      this.cdr.detectChanges();
    }else{
      this.errorOccurred = false
    }

    /**
     * check if viewType has changed, this case occurs when user re-configures the list panel
     * and changes the default view type
    */
    if(changes.panelMeta && changes.panelMeta.currentValue){

      let newMeta = changes.panelMeta['currentValue']
      // console.log("[data-table onChanges panelMeta changed", newMeta)
      // console.log("[data-table onChanges processed data", this.processedData)
      this.newViewType = newMeta?.viewTypes?.defaultView || "table"

      // this specifically detects when board grouping field is changed by user
      if (changes.panelMeta?.previousValue?.viewTypes?.boardStatusColumn?.__id !== changes.panelMeta?.currentValue?.viewTypes?.boardStatusColumn?.__id) {
        this.updateBoardView()
      }
    }

    /**
     * check if viewType changes from toggle button
     */
    if(changes.viewType && changes.viewType.currentValue){
      // console.log("[data-table onChanges] view type changed from toggle", changes.viewType)
      this.newViewType = changes.viewType.currentValue

      if(this.newViewType !== this.currentViewType){
        this.currentViewType = this.newViewType;
        this.decideViewTypeForScreenSize();
      }

      if(this.currentViewType == 'board'){
        // console.log("board view selected")
        this.widgetMetaMap = {
          groupValues: []
        }
        this.groupDataForBoard(this.tableData, this.panelMeta)
        this.createWidgetMetaMap(this.currentViewType)

        setTimeout(() => {
          if (!this.pillarWrapRef) { console.log("no pillarWrapRef"); return; }
          // console.log("board height", this.panelMeta.viewTypes.board?.height)
          this.renderer2.setStyle(
            this.pillarWrapRef?.nativeElement,
            'height',
            (this.panelMeta.viewTypes.boardHeight || '600') + 'px',
            // '300px',
            2 // RendererStyleFlags2.Important
          );
          // console.log("checking height", this.pillarWrapRef?.nativeElement?.clientHeight)
        }, 100);
      }else{
        this.widgetMetaMap = []
        this.createWidgetMetaMap(this.currentViewType)
      }
    }

    if(!this.currentViewType) {
      this.currentViewType = this.panelMeta.viewTypes?.defaultView || "table";
      // console.log("view type set to", this.currentViewType)
    }

    this.decideViewTypeForScreenSize();
    if(!this.widgetMetaMap) {
      // console.log("calling from onChanges() outside; no widget meta map now")
      this.createWidgetMetaMap(this.currentViewType)
    }
    this.createNavigationMap()
  }

  /**
   * this function recreates the widget metas for board view to reflect the new board grouping
   */
  updateBoardView(){
    console.log("update board view")
    this.widgetMetaMap = {
      groupValues: []
    }
    this.groupDataForBoard(this.tableData, this.panelMeta)
    this.createWidgetMetaMap(this.currentViewType)
  }

  processedDataChanged(newProcessedData: any[]){
    this.tableData = newProcessedData
    console.log(this.tableData)
    console.log("[DATA TABLE]: processedData changed", this.tableData, "calling createWidgetMetaMap")

    this.generateAttributeIds()

    this.tableInit()

    this.groupDataForBoard(this.tableData, this.panelMeta)
    this.createWidgetMetaMap(this.currentViewType)

    /**
     * TODO: support checkbox for board view
     * currently checkbox is only used in zoho crm extension, where board view is not used
     */
    if (this.currentViewType !== 'board') {
      this.initHeaderCheckbox()
    }
  }

  initHeaderCheckbox() {
   //waiting for all the child widgets to load and make checkbox checked if the checkbox contains in header.
    const isCheckboxExistInHeader = this.widgetMetaMap?.some((widget) => '__checkbox__' in widget)
    if (isCheckboxExistInHeader) {
      setTimeout(() => {
        this.headerCheckboxChange({ value: [''] })
      }, 1);
    }
  }

  onColumnsSelected(e){
    console.log("inn", this.selectedAttributes);
    this.panelMeta.listAttributes = this.selectedAttributes
    this.columnSelectionChanged.emit(this.panelMeta)
  }

  customOrder(attribute, order){
    attribute.order = order;
    console.log("attribute", attribute)
    this.customOrderChanged.emit(attribute)
  }

  ngOnInit(){
    if(!this.isBrowser) return;

    this.createNavigationMap()
    this.screenWidth = window.innerWidth;

    if(this.isSubPanel){
      this.generateAttributeIds()

      this.tableInit()

      this.createWidgetMetaMap(this.currentViewType);
      this.newViewType = this.panelMeta.viewTypes.defaultView;
      this.currentViewType = this.newViewType
      this.decideViewTypeForScreenSize();
    }

    if(!this.isInputData){
      this.bloomCode = this.router?.url?.split('/')?.[2]
      this.pageCode = this.router?.url?.split('/')?.[3]?.split('#')?.[0]
    }


    if(!this.isInputData && this.router?.url?.split('/')[1] == 'bloom'){
      this.route.fragment.pipe(takeUntil(this.destroy$)).subscribe(fragment => {
        if(fragment){
          this.isFragment = true
          this.fragment = fragment
          console.log("fragment detected", fragment)
        }
      })
    }else{
      this.isFragment = false;
    }
    const savedWidths = localStorage.getItem('table-column-widths');
    if (savedWidths) {
      this.columnWidths = JSON.parse(savedWidths);
      
      // Apply saved widths to columnData
      for (let i = 0; i < this.columnData.length; i++) {
        const colId = this.attributeIds[i];
        if (this.columnWidths[colId]) {
          this.columnData[i].colWidth = this.columnWidths[colId];
        }
      }
    }
  }

  // Method to start resize
  startResize(event: MouseEvent, columnIndex: number) {
    this.resizing = true;
    this.currentColumn = columnIndex;
    this.startX = event.pageX;
    
    // Get current width
    const colWidth = this.columnData[columnIndex].colWidth;
    // Handle both pixel and percentage values
    if (colWidth.endsWith('px')) {
      this.startWidth = parseInt(colWidth, 10);
    } else if (colWidth.endsWith('%')) {
      // Convert percentage to pixels for resize operation
      const headerElement = (event.currentTarget as HTMLElement).parentElement as HTMLElement;
      const totalWidth = headerElement.offsetWidth;
      const percentage = parseFloat(colWidth);
      this.startWidth = (percentage / 100) * totalWidth;
    } else {
      this.startWidth = 100; // Default width if no unit specified
    }
    
    // Store previous width
    this.previousWidths[columnIndex] = colWidth;
    
    // Prevent text selection while resizing
    event.preventDefault();
  }

  // Track mouse movement for resizing
  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.resizing) {
      return;
    }
    
    const dx = event.pageX - this.startX;
    const newWidth = Math.max(50, this.startWidth + dx); // Minimum width of 50px
    
    this.columnData[this.currentColumn].colWidth = `${newWidth}px`;
  }

  // End resize operation on mouse up
  @HostListener('document:mouseup')
  onMouseUp() {
    if (this.resizing) {
      this.resizing = false;
      this.saveColumnWidths();
    }
  }

  // Save column widths
  saveColumnWidths() {
    const widths = this.columnData.map(col => col.colWidth);
    localStorage.setItem('table-column-widths', JSON.stringify(widths));
  }

  getCurrentViewType(){
    if(this.screenWidth < 440) {
      return "card";
    } else return this.currentViewType || this.panelMeta.viewTypes?.defaultView || "table";
  }

  // contextChanged(contextActions){
  //   console.log("context changed", contextActions)
  //   for(var key in this.panelMeta.listWidgetSet){
  //     console.log("key", key)
  //     let widget = this.panelMeta.listWidgetSet[key];
  //     console.log("proto widget is", widget)
  //     if(widget.id == contextActions.widgetId){
  //       console.log("id matched")
  //       this.updateWidgetPrototype(widget, key, contextActions['propertyName'] || '')
  //       // this.createWidgetMetaMap(this.currentViewType)
  //     }
  //   }
  // }

  menuOpened(widget){
    console.log("opend", widget);
    console.log("opend id", this.prevContextWidgetId, widget.id);
    if(this.prevContextWidgetId && this.prevContextWidgetId !== widget.id){
      if (this.contextMenuTrigger && this.contextMenuTrigger.menuOpen) {
        this.contextMenuTrigger.closeMenu()
      }
    }
    // this.metaChange.emit(this.panelMeta)

    this.prevContextWidgetId = widget.id;
  }

  ngAfterViewInit(): void {
    // this.maxImageHeight = this.dataCard[0].nativeElement.clientWidth
  }

  generateAttributeIds(){
    this.attributeIds = [];
    console.log("panelMeta", JSON.parse(JSON.stringify(this.panelMeta)))
    this.panelMeta.listAttributes.forEach(attr => {
      if(attr.isColumnSelected){
        if(attr.isDrillDown){
          attr.nestedProperties.forEach(nestedProp => {
            if(nestedProp.path) this.attributeIds.push(attr.__id + '.' + nestedProp.path)
          })
        }else{
          this.attributeIds.push(attr.__id)
        }
        this.listAttributes.push(attr)
      }
    })
    console.log("[DATA TABLE] attribute ids", this.attributeIds);
  }

  tableInit(){
    this.columnData = []
    let iconColumnCount: number = this.panelMeta.listAttributes.filter(attr => attr.fieldType == 'icon').length
    let autoColWidth = Math.floor((100 - (iconColumnCount * 5)) / (this.attributeIds.length - iconColumnCount))
    this.panelMeta.listAttributes.forEach(attr => {
      if((attr.fieldType == 'attribute') && attr.isColumnSelected){
        if(attr.isDrillDown){
          attr.nestedProperties.forEach(nestedProp => {
            if(nestedProp.path){
              this.columnData.push({
                headerWidget: this.getHeaderWidget(nestedProp.headerTitle || (attr.name + " > " + nestedProp.path)),
                colWidth: autoColWidth
              })
            }
          })
        }else{
          this.columnData.push({
            headerWidget: this.getHeaderWidget(attr.name),
            colWidth: autoColWidth
          })
        }
      }else if(attr.fieldType == 'label' || attr.fieldType == 'button'){
        this.columnData.push({
          headerWidget: this.getHeaderWidget(attr.columnName),
          colWidth: autoColWidth
        })
      } else if(attr.fieldType == 'icon'){
        this.columnData.push({
          headerWidget: this.getHeaderWidget(attr.columnName),
          colWidth: 5
        })
      } else if(attr.fieldType == 'checkbox') {
        this.columnData.push({
          headerWidget: this.getHeaderWidget(attr.columnName, attr.widgetType),
          colWidth: 2
        })
      }
    });
  }

  getHeaderWidget(columnName: string, widgetType?: string){
    let newWidget: any = WidgetManager.getWidget(widgetType || 'label')

    //if type is checkbox, then replacing existing static options with single option.
    if (widgetType === "checkbox") {
      const staticOption = {
        name: '',
        value: '',
        default: true,
        type: 'static'
      };

      newWidget.config.availableOptions.staticOptions = [staticOption];
      newWidget.config.title.show = false;
    } else {
      // newWidget.setValue(columnName?.toString()?.length > 15 ? columnName?.toString()?.slice(0, 15) + '...' : columnName?.toString() || "")
      columnName = columnName.toString()
      if(this.panelMeta?.formatWidgetHeaderInTitleCase){
        columnName = columnName?.replace(/^[^a-zA-Z0-9]+/, '').replace(/^$/, columnName) // Remove only leading special characters
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
      }
      this.widgetSetValue(newWidget, columnName.length > 15 ? columnName?.slice(0, 15) + '...' : columnName || "")
      newWidget.config.tooltip.value = columnName;
    }
    return newWidget
  }


  paginatorEvent(event: any){
    console.log("paginator event hit", event)
    this.raisePageEvent.emit(event)
  }

  createNavigationMap(){
    let navMap: any = {}
    if(this.panelMeta.navigationSettings?.enabled) return
    this.panelMeta?.listAttributes?.forEach(attr => {
      if(!attr.isDrillDown && attr.navigationSettings && attr.navigationSettings.enabled){
        navMap[attr.__id] = attr.navigationSettings
      }
    });
    this.navMap = navMap
    // console.log("navigation map:", this.navMap)
  }

  cardClicked(event, rowIndex){
    console.log("card clicked")
    if(!this.builderMode && this.panelMeta.navigationSettings?.enabled){
      console.log("card level nav enabled", this.panelMeta.navigationSettings)
      if(this.panelMeta.navigationSettings?.type == 'internal'){
        this.navigateInternal(rowIndex, undefined, undefined, true)
      }else if(this.panelMeta.navigationSettings?.type == 'external'){
        this.navigateExternal(rowIndex, undefined, true)
      }else if(this.panelMeta.navigationSettings?.type == 'relative'){
        this.navigateRelative(rowIndex, undefined, true)
      };

      let item = {
        actionId: null,
        data: this.tableData[rowIndex],
        index: rowIndex,
        rowDataRaw: this.rawBoxData?.[rowIndex]
      }
      this.selectedRowData.emit(item);
    }
  }

  rowCheckboxSelected(userInput: any, rowIndex?: number) {
    // console.log('USERINPUT', userInput, 'ROW:', rowIndex)
    if (userInput.value?.[0] == '') {
      this.selectedRows[rowIndex] = this.rawBoxData?.[rowIndex];
    } else {
      delete this.selectedRows[rowIndex];
    }
  }

  emitCheckboxChange() {
    this.checkboxSelected.emit(this.selectedRows);
  }

  headerCheckboxChange(data) {
    // console.log("header checkbox change", data)
    // console.log("widget meta map", JSON.parse(JSON.stringify(this.widgetMetaMap)))
    for (let i = 0; i < this.widgetMetaMap.length; i++) {
      const rowWidgets = this.widgetMetaMap[i];
      const checkboxWidget = rowWidgets.__checkbox__;
      // if (checkboxWidget?.config?.availableOptions?.staticOptions?.[0]) {
      //   checkboxWidget.config.availableOptions.staticOptions[0].default = Array.isArray(data.value) ? data.value[0] == '' : false;
      // }

      // delegate value change to the individual widgets, widget components take care of emitting value change
      // will be caught by rowCheckboxSelected function
      checkboxWidget.config.value.value = data.value;
      let emitterData = {
        actionType: 'updateStyles',
        data: checkboxWidget,
        widgetId: checkboxWidget.id
      }
      this.metaService.setContextChanged(emitterData)
      // this.rowCheckboxSelected(data, i)
    }
    // console.log("selected rows", JSON.parse(JSON.stringify(this.selectedRows)))
    this.emitCheckboxChange();
  }

  widgetClicked(widgetMeta: any) {
    console.log("widget clicked", widgetMeta)
    this.widgetService.openWidgetSidebarSettings.next({
      panelId: this.panelMeta.id,
      widgetMeta: widgetMeta
    })
  }

  async valueReceived(event: any, rowIndex: any, attrId: any) {
    // Debounce key for this field
    const debounceKey = `${rowIndex}_${attrId}`;
    // Clear any existing timer
    if (this.valueTimers[debounceKey]) {
      clearTimeout(this.valueTimers[debounceKey]);
    }

    // Set new timer
    this.valueTimers[debounceKey] = setTimeout(() => {
      this.processValue(event, rowIndex, attrId);
      // Optionally clear the timer reference
      delete this.valueTimers[debounceKey];
    }, 1000);
    
  }

  // The inline edit function that executes after debounce
  async processValue(event: any, rowIndex: any, attrId: any) {
    this.widgetMetaMap[rowIndex][attrId]['config']['viewOnly']['value'] = true;
    if (this.rawBoxData?.[rowIndex][attrId] === event.value) return;
    let data = this.rawBoxData?.[rowIndex];
    let boxToken: any;
    let boxId = this.panelMeta?.boxId
    data[attrId] = event?.value;

    let payload = {
      parameters: {
        data: [data],
        options: this.inputParams || {},
      },
    };

    let options = {
      actionMap : {
        boxId : boxId,
        baseMap: this.panelMeta.baseMap,
        boxConfigToken: this.panelMeta?.boxConfigToken,
        connection: this.panelMeta.connectionId,
        action: `${this.panelMeta.boxObjectId}/update`,
        payload: payload,
        successMessage: "Updated Successfully." 
      }
    }
    let res = await this.getApplicationAction().doAction(options)
    if(res?.status === 'success') this.processedData[rowIndex][attrId].value = event.value;
    if (res?.status === 'failure'){
      // If failed restore the table with previous data
      this.processedDataChanged(this.processedData)
    }
    console.log("Processed Data : ", JSON.parse(JSON.stringify(this.processedData)))
  }

  async doOnClickAction(rowIndex: number, attrId: string, groupVal?: any){
    
    // handle widget manipulation based on data structure of selected view
    if (this.currentViewType !== 'board') {
      if(this.widgetMetaMap[rowIndex][attrId]?.inlineEditEnabled) this.widgetMetaMap[rowIndex][attrId].config.viewOnly.value = false;
    } else if (groupVal){
      if(this.widgetMetaMap[groupVal]?.[rowIndex][attrId]?.inlineEditEnabled) this.widgetMetaMap[groupVal][rowIndex][attrId].config.viewOnly.value = false;
    }
    console.log("rawBoxData", this.rawBoxData?.[rowIndex])
    if (attrId == '__checkbox__') return;
    let item = {
      actionId: attrId,
      data: this.tableData[rowIndex],
      index: rowIndex,
      rowDataRaw: this.rawBoxData?.[rowIndex],
      attribute: this.panelMeta.listAttributes.find(attr => attr.__id == attrId)
    }
    if(attrId == 'delete'){
      item.actionId = "deleteById"
    }
    this.selectedRowData.emit(item)

    let res = this.panelMeta.listAttributes.find(attr => {
      return attr.__id == attrId
    })
    let currentAttr = JSON.parse(JSON.stringify(res))
    console.log(currentAttr)
    if(!currentAttr) {
      console.log("no click action for nested attributes")
      return
    }

    if(!currentAttr.eventType || currentAttr.eventType == "navigation"){
       this.doNavigate(rowIndex, attrId, groupVal);
    } else if (currentAttr.eventType == "action") {
      if (currentAttr.actionConfig.action == 'application' && attrId == 'delete') {
        let dialogRef = this.dialog.open(DeleteDialogComponent, {
          width: '600px',
          data: {
            resourceName: "record",   // TODO: use softcoded record name for respective app; row|line|record etc
            resource: this.panelMeta.boxObjectId,
            dataObj: item.rowDataRaw,
            isAppData: true
          },
        });
        dialogRef.afterClosed().subscribe(async (deleteConfirmed) => {

          if (deleteConfirmed) {

            try {
              let deleteMarker = Date.now()
              this.rawBoxData[rowIndex]['__deleteMarker'] = deleteMarker
              this.processedData[rowIndex]['__deleteMarker'] = deleteMarker
              this.deletionProgressRecordMap[rowIndex] = JSON.parse(JSON.stringify(this.rawBoxData[rowIndex]));
              this.cdr.detectChanges()

              if(currentAttr?.actionConfig?.actionMap){
                currentAttr.actionConfig.actionMap.valueMap = this.rawBoxData[rowIndex];
                currentAttr.actionConfig.actionMap.boxId = this.panelMeta?.boxId;
                currentAttr.actionConfig.actionMap.connection = this.panelMeta?.connectionId;
                currentAttr.actionConfig.actionMap.action = `${this.panelMeta?.boxObjectId}/deleteById`;
                currentAttr.actionConfig.actionMap.actionMode = `deleteById`;
                currentAttr.actionConfig.actionMap.primaryAttr = this.panelMeta?.primaryAttribute;
              }
              setTimeout(async() => {
                await this.getApplicationAction().doAction(currentAttr.actionConfig, {type: "click"});
                let obj =  this.deletionProgressRecordMap[rowIndex];
                this.processedData.splice(this.processedData.findIndex(dataRow=>dataRow.__deleteMarker == obj.__deleteMarker),1)
                this.rawBoxData.splice(this.rawBoxData.findIndex(dataRow=>dataRow.__deleteMarker == obj.__deleteMarker),1)
                delete this.deletionProgressRecordMap[rowIndex]
                console.log("deleted from processed data", JSON.parse(JSON.stringify(this.processedData || [])))
                this.processedDataChanged(JSON.parse(JSON.stringify(this.processedData)))
                this.cdr.detectChanges()
              })
            } catch (error) {
              console.log("Could not delete record", error)
              delete this.rawBoxData[this.rawBoxData.findIndex(row => row.__deleteMarker == this.deletionProgressRecordMap[rowIndex].__deleteMarker)]['__deleteMarker']
              delete this.processedData[this.processedData.findIndex(row => row.__deleteMarker == this.deletionProgressRecordMap[rowIndex].__deleteMarker)]['__deleteMarker']
              delete this.deletionProgressRecordMap[rowIndex]
              this._snackBar.open("Could not delete record", "",  {duration: 2000});
              throw error
            }
          }
        })
        //if function is create
      } else if(currentAttr.actionConfig?.action == 'application' && currentAttr?.actionConfig?.actionMap?.action?.includes('create') ) {
        currentAttr.actionConfig.actionMap.valueMap = this.rawBoxData[rowIndex];
        // this.runSpinner = true;
        let result = await this.getApplicationAction().doAction(currentAttr.actionConfig, {type: "click"});
        // this.runSpinner = false;

        //if data present add it into existing list
        if(result?.data?.[0]?.data){
          let createdRecord = result?.data[0]?.data;
          let clonedData = this.listPanelService.processData([createdRecord], this.panelMeta);
          // Insert clonedData after the specified rowIndex
          if (Array.isArray(clonedData) && clonedData.length > 0) {
            this.rawBoxData.splice(rowIndex + 1, 0, createdRecord);
            this.processedData.splice(rowIndex + 1, 0, ...clonedData);
            this.processedDataChanged(JSON.parse(JSON.stringify(this.processedData)));
          }
        } else { // refresh list panel
          this.refreshData.emit(true);
        }
        this.cdr.detectChanges()
      } else if (['resource-deletion', 'record-deletion'].includes(currentAttr.actionConfig.action)) {
        console.log("resource deletion", this.rawBoxData[rowIndex])
        // await this.deleteResource(item)
        this.rowDeletion.emit(item)
      }
    } else if (currentAttr.eventType.startsWith('popup')) {
      console.log("popup action", currentAttr)
      this.handlePopupAction(rowIndex, currentAttr)
    }
  }




  async handlePopupAction(rowIndex: number, attr: any){
    // console.log("handle popup action", attr)
    // console.log("rowIndex", rowIndex)
    // console.log("data", this.rawBoxData)
    if(attr.eventType == 'popup-edit'){
      this.runSpinner = true
      // console.log("form panel", JSON.parse(JSON.stringify(formPanel)))
      let formPanel: any = await this.automationService.generatePopupForm(this.panelMeta, this.rawBoxData[rowIndex], attr.updateFnOptions)
      formPanel['actionFnOptions'] = attr.updateFnOptions
      formPanel = this.automationService.generateFormWidgets(formPanel.formAttributes, formPanel)
      // console.log("form panel after widgets", JSON.parse(JSON.stringify(formPanel))
      this.runSpinner = false
      this.automationService.openPopupDialog(formPanel)

    } else if (attr.eventType == 'popup-view') {
      this.runSpinner = true
      let detailsPanel: any = await this.automationService.generatePopupDetails(this.panelMeta, this.rawBoxData[rowIndex])
      console.log("details panel created", JSON.parse(JSON.stringify(detailsPanel)))
      detailsPanel['layoutMap'] = this.automationService.generateDetailsWidgets(detailsPanel)
      console.log("details panel after widgets addition", detailsPanel)
      this.runSpinner = false
      this.automationService.openPopupDialog(undefined, detailsPanel)

    } else if (attr.eventType == 'popup-view-edit') {
      this.runSpinner = true
      let formPanel: any = await this.automationService.generatePopupForm(this.panelMeta, this.rawBoxData[rowIndex], attr.updateFnOptions)
      formPanel['actionFnOptions'] = attr.updateFnOptions
      formPanel = this.automationService.generateFormWidgets(formPanel.formAttributes, formPanel)
      let detailsPanel: any = await this.automationService.generatePopupDetails(this.panelMeta, this.rawBoxData[rowIndex])
      detailsPanel['layoutMap'] = this.automationService.generateDetailsWidgets(detailsPanel)
      this.runSpinner = false
      this.automationService.openPopupDialog(formPanel, detailsPanel)
    }
  }

  doNavigate(rowIndex: number, attrId: string, groupVal?: any){
    // console.log("nav map for attr", rowIndex, attrId, this.navMap[attrId])

    // console.log("nav map", this.navMap)
    // console.log("nav map for attr", this.navMap[attrId])
    if(!this.navMap[attrId] || !this.navMap[attrId].enabled || !this.navMap[attrId].type) {
      // console.log("no navigation exists for this attribute!!")
      return
    }

    if(!this.builderMode){
      if((this.navMap[attrId].type == 'internal' || this.navMap[attrId].type == 'relative') ){
        this.navigateInternal(rowIndex, attrId, groupVal)
      }else if(this.navMap[attrId].type == 'external'){
        this.navigateExternal(rowIndex, attrId)
      }
    }
  }

  navigateRelative(rowIndex, attrId, groupValue?: any, fullCardNav?: boolean){

  }

  decideViewTypeForScreenSize(){
    this.currentViewType = this.screenWidth < 440 ? "card" : this.currentViewType;
    return this.currentViewType
  }

  navigateInternal(rowIndex, attrId, groupValue?: any, fullCardNav?: boolean){
    // console.log("rowIndex", rowIndex, "attrId", attrId)
    // console.log("navigate internal hit, navigation settings", this.panelMeta)
    let isRelative: boolean
    let relativeUrl: string = ""
    let navFilterAttributes
    let destinationPageCode
    if(!fullCardNav){
      let currentAttr = this.panelMeta.listAttributes.find(attr => attr.__id == attrId)
      // console.log(currentAttr)
      navFilterAttributes = currentAttr.navigationSettings.navFilterAttributes
      destinationPageCode = this.navMap[attrId]['pageCode']
      isRelative = currentAttr.navigationSettings.type == 'relative' ? true : false
      relativeUrl = currentAttr.navigationSettings.type == 'relative' ? currentAttr.navigationSettings.linkUrl : ""
      // console.log("navFilterAttributes", currentAttr.navigationSettings.navFilterAttributes)
    }else{
      navFilterAttributes = this.panelMeta.navigationSettings?.navFilterAttributes
      destinationPageCode = this.panelMeta.navigationSettings?.['pageCode']
      isRelative = this.panelMeta.navigationSettings.type == 'relative' ? true : false
      relativeUrl = this.panelMeta.navigationSettings.type == 'relative' ? this.panelMeta.navigationSettings.linkUrl : ""
    }

    // let rowData: any = this.processedData[rowIndex]
    let data = []
    let queryParams:any = {
      // _destinationPageCode: destinationPageCode
    };

    let pathParams = "";
    navFilterAttributes.forEach(attr => {
      // console.log("nav attr", attr, "rawBoxdata", this.rawBoxData)

      let value;
      if(this.currentViewType == 'board' && groupValue){
        let groupColumn = this.panelMeta.viewTypes.boardStatusColumn.__id
        // this.rawBoxData
        let filteredList = this.rawBoxData.filter(obj => obj[groupColumn] == groupValue)
        // console.log("filteredList", filteredList)
        value = filteredList[rowIndex][attr.__id]
        // console.log("value:", value)
      }else{
        value = this.rawBoxData[rowIndex][attr.__id]
      }

      // data.push({
      //   attributeId: attr.__id,
      //   parameter: attr.parameter || attr.__id,
      //   value: value,
      //   dataType: attr.dataType
      // })

      // queryParams[encodeURIComponent(attr.parameter || attr.__id)] = encodeURIComponent(value);
      pathParams = pathParams + "/" + encodeURIComponent(attr.parameter || attr.__id) + "/" + encodeURIComponent(value);
      // queryParams["destination-page-code"] = destinationPageCode;
    });

    // let dataToSend = {
    //   subscriptionId: Date.now(),
    //   filters: JSON.parse(JSON.stringify(data)),
    //   _sourcePageCode: this.pageCode,
    //   "destination-page-code": destinationPageCode
    // };

    // console.log("dataToSend", dataToSend)
    console.log("destination page code", destinationPageCode)
    console.log("destination url", '/bloom/' + this.bloomCode + '/' + destinationPageCode)

    // this.pageService.navigationData.next(dataToSend)

    this.pageService.savePageRequest.next(true)

    let version: string
    let latestVersion = false;
    let pageStructureMap
    this.metaService.get_bloomMeta.pipe(takeUntil(this.destroy$)).subscribe((bloomMeta: any) => {
      version = bloomMeta.version;
      latestVersion = bloomMeta.latest
      pageStructureMap = bloomMeta.page_structure_map;
    })
    
    if(isRelative){
      // console.log("current route", this.router.url)
      // let parts = this.router.url.split("/")
      // parts = parts.filter(p => p.length)
      // console.log("parts", parts)
      // console.log("last part", parts[parts.length - 1])
      // if(relativeUrl.startsWith(".")) relativeUrl = relativeUrl.substring(1)
      // if(relativeUrl.startsWith("/")) relativeUrl = relativeUrl.substring(1)
      // // if(queryString) relativeUrl += queryString

      // // relativeUrl = "/" + parts[parts.length - 1] + "/" + relativeUrl
      // let urlTree = parts.concat([relativeUrl])

      // console.log("final url tree for relative navigation", urlTree)
      // let url = ""
      // urlTree.forEach(path => url = url + "/" + path)
      // console.log("navigating to", url)
      // this.router.navigateByUrl(url)
    }
    let pagePath = this.pageService.getPagePathByIdOrCode(pageStructureMap, destinationPageCode);
    // let pagePathSegments = pagePath?.split('/') || [];
    console.log("pagePath innnn", pagePath)

    if(this.isFragment && !this.metaService.previewMode){
      this.router.navigate(['/bloom/' + this.bloomCode + '/' + pagePath], {fragment: this.fragment});
    } else{
      if(!latestVersion && version != "latest" && !this.metaService.previewMode) {
        queryParams.v = version;
        pathParams = pathParams + "/v/" + version;
      }
      if(pathParams) pathParams = "/q" +  pathParams;
      if(!this.metaService.previewMode) {
        this.router.navigate(['/p/' + this.bloomCode + '/' + pagePath + pathParams]);
      } else { //for preview mode
        this.metaService.bloomPreviewMap[destinationPageCode] = {};
        this.metaService.bloomPreviewMap[destinationPageCode].pathParams = pathParams;
        this.pageService.navigationData.next({pathParams: pathParams, isActionNav: true, "pageCode": destinationPageCode});
      };

    }
  }


  navigateExternal(rowIndex, attrId, fullCardNav: boolean = false){
    if(fullCardNav){
      window.open(this.panelMeta.navigationSettings.linkUrl, "_blank");
    }else{
      console.log("data", this.rawBoxData[rowIndex])
      console.log("nav map for attr", this.navMap[attrId])
      let te = new TemplateEngine()
      let finalLink = te.fill(this.navMap[attrId].linkUrl, this.rawBoxData[rowIndex])
      window.open(finalLink, "_blank");
    }
  }


  openListPanel(obj, key) {
    this.runSpinner = true;
    if(obj && typeof obj == 'string'&& obj.length > 20) {
      return;
    }

    // open dialog to collect options
    let data: any = {
      data: obj,
      key: key
    }

    if (Array.isArray(obj)) {
      let firstElem = obj[0];
      if(firstElem instanceof Object){
        data.type = "arrayofobjects";
      } else {
        data.type = "arrayofprimitives";
      }
    } else if(obj instanceof Object){
      data.type = "object";
    }

    // this.listPanelService.subPanelMetas = [];
    this.listPanelService.subPanelMeta = {};
    this.runSpinner = false;
    this.subPanel.emit(data);
  }

  getNumberOfFields(value){
    let result:any = {text: "", tooltext: ""};

    if (Array.isArray(value)) {
      let firstElem = value[0];
      if(firstElem instanceof Object){
        result.text = `[ ${value?.length} ]`;
        result.tooltext = `${value?.length} objects. Click to see details`
      } else {
        let elements = value.slice(0, 5);
        let cus = [];
        elements.forEach(e => {
          if(e != typeof 'string')e = JSON.stringify(e);
          if(e.length > 5){
            cus.push(e.substring(0, 5) + "..");
          } else cus.push(e)
        })
        result.text = `[${cus}]`;
        result.tooltext = `${value?.length} elements. Click to see details`
      }

    } else if(value instanceof Object){
      result.text = `${Object.keys(value).length ? `{ ${Object.keys(value).length} }` : "{}"}`;
      result.tooltext = `${Object.keys(value).length ? `${Object.keys(value).length} fields. Click to see details` : "0 fields"}`;``
    }
    // else if(value && typeof value == 'string'&& value.length > 20 && value.indexOf("https://") == -1) {
    //   result.text = `${value.substring(0, 20)}...`
    //   result.tooltext = value
    // }
    return result;
  }

  isObjectValue(value){
    let result = false;
    if(value && value instanceof Object || value instanceof Array){
      result = true;
    }
    // else if (value && typeof value == 'string' && value.length > 20 && value.indexOf("https://") == -1){
    //   result = true;
    // }
    return result;
  }


  // creates widgets and puts it in an appropriate data structure
  createWidgetMetaMap(viewType: string){
    console.log("create widget meta map called, table data", JSON.parse(JSON.stringify(this.tableData || [])))
    // this.ready = false
    if(!viewType) viewType = this.panelMeta.viewTypes?.defaultView
    if(viewType == 'table' || viewType == 'card'){
      this.widgetMetaMap = []
      if(!this.tableData) return;
      for (let i = 0; i < this.tableData.length; i++) {
        let rowData = this.tableData[i]
        let rowMetaMap = {}

        // let attrIds = Object.keys(rowData)
        let attrIds = []
        let attributes = this.panelMeta.listAttributes.filter(attr => attr.isColumnSelected)
        // console.log("attributes selected to show", JSON.parse(JSON.stringify(attributes)))
        attributes.forEach(attr => {
          // if(rowData[attr.__id] == undefined || rowData[attr.__id] == '') return
          if(!attr.isDrillDown){
            attrIds.push(attr.__id)
            // console.log("added to list", attr.__id)
          }else{
            // if(typeof(rowData[attr.__id]) != 'object' || !Object.keys(rowData[attr.__id]).length) return
            attr.nestedProperties.forEach(nestedProp => {
              attrIds.push(`${attr.__id}.${nestedProp.path}`)
              // let val = this.widgetUtilityService.getDeepObjectValue(rowData[attr.__id], nestedProp.path)
              // if(val != undefined && val != '') attrIds.push(`${attr.__id}.${nestedProp.path}`)
            });
          }
        })
        for (let j = 0; j < attrIds.length; j++) {
          const attrId = attrIds[j];
          // if _recordId, no need to create widgetMeta
          if(attrId == '__recordId'){
            rowMetaMap[attrId] = rowData[attrId]
            continue
          }

          if(this.panelMeta.listWidgetSet && this.panelMeta.listWidgetSet[attrId]){
            let widgetProto = this.panelMeta?.listWidgetSet[attrId]
            // console.log("widget proto found", widgetProto)
            // let widgetType = this.getWidgetType(attrId)
            let newWidget: any = WidgetManager.getWidget(rowData[attrId]?.widgetType || 'label')
            Object.keys(widgetProto).forEach(prop => {
              if(prop !== 'id') {
                newWidget[prop] = JSON.parse(JSON.stringify(widgetProto[prop]))
              }
            })
            // console.log("after prop copy", newWidget)

            rowMetaMap[attrId] = this.prepareWidget(newWidget, rowData, attrId)

            // if(newWidget.type == 'label') {
            //   if(!newWidget.config.tooltip) {
            //     let labelWid = WidgetManager.getWidget('label')
            //     newWidget.config.props.push('tooltip')
            //     newWidget.config.tooltip = JSON.parse(JSON.stringify(labelWid.config.tooltip))
            //   }
            //   if(typeof rowData[attrId]?.value == 'string' && rowData[attrId]?.value?.length > 500){
            //     newWidget.config.tooltip.value =  rowData[attrId]?.value?.substring(0, 500)
            //   }else if(typeof rowData[attrId]?.value == 'string' && rowData[attrId]?.value?.length <= 15){
            //     newWidget.config.tooltip.value = ''
            //   } else {
            //     newWidget.config.tooltip.value = rowData[attrId]?.value
            //   }
            //   if(rowData[attrId]?.value?.length && rowData[attrId]?.value?.length >= 500) rowData[attrId].value += '...'
            // }

            // if(newWidget.type == 'tags'){
            //   if(!rowData[attrId]?.value) rowData[attrId].value = [];
            // }
            // console.log("will set value", JSON.parse(JSON.stringify(rowData[attrId]?.value || "")))

            // SET THE VALUE INTO WIDGET
            // if (newWidget.type == 'image'){
            //   // newWidget.setValue(rowData[attrId]?.value?.toString() || newWidget.config.value.resetValue || '')
            //   this.widgetSetValue(newWidget, rowData[attrId]?.value?.toString() || newWidget.config.value.resetValue || '')
            // } else if (newWidget.type == 'tags') {
            //   // newWidget.setValue(rowData[attrId]?.value)
            //   this.widgetSetValue(newWidget, rowData[attrId]?.value)
            // } else {
            //   if (rowData[attrId]?.value?.toString()?.length > 50){
            //     // newWidget.setValue(rowData[attrId]?.value?.toString()?.slice(0, 50) + '...')
            //     this.widgetSetValue(newWidget, rowData[attrId]?.value?.toString()?.slice(0, 50) + '...')
            //   } else {
            //     // newWidget.setValue(rowData[attrId]?.value?.toString() || '')
            //     this.widgetSetValue(newWidget, rowData[attrId]?.value?.toString() || '')
            //   }
            // }

            // newWidget.type !== 'image'
            //   ? newWidget.setValue(rowData[attrId]?.value?.toString()?.length > 50 ? rowData[attrId]?.value?.toString()?.slice(0, 50) + '...' : rowData[attrId]?.value?.toString() || '')
            //   : newWidget.setValue(rowData[attrId]?.value?.toString() || '')

            // console.log("widget created", rowMetaMap[attrId])
          }
          // if(rowData[attrId]?.widgetType == 'link'){
          //   rowMetaMap[attrId]['config']['tooltip']['value'] = rowData[attrId]?.value || "";

          //   rowMetaMap[attrId]['config']['linkText']['value'] = "Click to navigate";
          //   console.log("link widget created", rowMetaMap[attrId])
          // }
          // // console.log("rowMetaMap", rowMetaMap)
          // if(rowData[attrId]?.widgetType == 'datetime'){
          //   if(rowMetaMap[attrId]['config']['viewOnly']){
          //     rowMetaMap[attrId]['config']['viewOnly']['value'] = true;
          //   }else{
          //     let wid = WidgetManager.getWidget('datetime')
          //     rowMetaMap[attrId].config.props.push('viewOnly')
          //     rowMetaMap[attrId]['config']['viewOnly'] = wid.config.viewOnly
          //     rowMetaMap[attrId]['config']['viewOnly']['value'] = true;
          //   }
          //   // console.log(rowMetaMap[attrId]['config']['viewOnly'])
          //   rowMetaMap[attrId].config.placeholder.value = '';
          //   if(!rowData[attrId].value) rowData[attrId].value = null;
          // }

          // if(rowData[attrId]?.widgetType == 'checkbox'){
          //   rowMetaMap[attrId]['config']['title']['show'] = false;
          //   rowMetaMap[attrId]['config']['value']['value'] = [''];
          //   rowMetaMap[attrId]['config']['availableOptions']['staticOptions'] = [{
          //     name: '',
          //     value: '',
          //     default: false,
          //     type: 'static'
          //   }];
          // }

          // if(rowData[attrId]?.widgetType == 'tags'){
          //   rowMetaMap[attrId]['config']['tagType']['value'] = "Stroked";
          // }

          // if(!rowData[attrId]?.value && !['image', 'checkbox'].includes(rowData[attrId]?.widgetType)){
          //   rowMetaMap[attrId]?.setValue('${reset}')
          // }


          // if(rowData[attrId]?.widgetType == 'icon'){
          //   // console.log("rowMetaMap", JSON.parse(JSON.stringify(rowMetaMap)))
          //   let attr = attributes.find(a => a.__id == attrId)
          //   // console.log("attr", attr, "rowData", rowData)
          //   if (attr['conditionalConfig']?.enabled) {
          //   rowMetaMap[attrId]['config']['conditionalConfig'] = attr['conditionalConfig']
          //   } else {
          //     rowMetaMap[attrId]['config']['tooltip']['value'] = rowData[attrId]?.columnName || "";
          //   }

          //   if (!rowMetaMap[attrId]?.['config']?.['alignment']) {
          //     console.log("inside if", rowMetaMap[attrId])
          //     let newWid = WidgetManager.getWidget('icon')
          //     rowMetaMap[attrId]['config']['props'].push('alignment')
          //     rowMetaMap[attrId]['config']['alignment'] = newWid['config']['alignment']
          //   }
          //   rowMetaMap[attrId]['config']['alignment']['value'] = 'start'
          //   // console.log("icon widget ammended", rowMetaMap[attrId])
          // }

          // if(rowData[attrId]?.widgetType == 'autocomplete'){
          //   console.log("AC widget created", JSON.parse(JSON.stringify(rowMetaMap[attrId])))
          //   if (this.panelMeta?.inlineEditEnabled || rowMetaMap[attrId]?.inlineEditEnabled) {
          //     rowMetaMap[attrId]['config']['viewOnly']['value'] = true;
          //     rowMetaMap[attrId]['config']['viewOnly']['hidden'] = true;
          //   } else {
          //     rowMetaMap[attrId]['config']['viewOnly']['value'] = true
          //   }
          //   rowMetaMap[attrId]['config']['title']['value'] = ''
          // }

          // if(rowData[attrId]?.widgetType == 'select'){
          //   console.log("AC widget created", JSON.parse(JSON.stringify(rowMetaMap[attrId])))
          //   if (this.panelMeta?.inlineEditEnabled || rowMetaMap[attrId]?.inlineEditEnabled) {
          //     rowMetaMap[attrId]['config']['viewOnly']['value'] = true;
          //     rowMetaMap[attrId]['config']['viewOnly']['hidden'] = true;
          //   } else {
          //     rowMetaMap[attrId]['config']['viewOnly']['value'] = true
          //   }
          //   rowMetaMap[attrId]['config']['title']['value'] = ''
          // }
          // console.log("meta created", rowMetaMap[attrId])
        }
        // console.log("row meta created", JSON.parse(JSON.stringify(rowMetaMap || {})))

        this.widgetMetaMap[i] = rowMetaMap
      }
    }else if(viewType == 'board'){
      console.log("[createWidgetMetaMap] board view")
      console.log("groupedData", this.groupedData)
      this.widgetMetaMap = {
        groupValues: []
      }

      for (let i = 0; i < this.groupedData.groupValues.length; i++) {
        let groupVal: string = this.groupedData.groupValues[i]

        this.widgetMetaMap['groupValues'].push(groupVal)
        this.widgetMetaMap[groupVal] = []

        for (let i = 0; i < this.groupedData[groupVal].length; i++) {
          let rowData = this.groupedData[groupVal][i]
          let rowMetaMap = {}

          let attrIds = Object.keys(rowData)
          for (let j = 0; j < attrIds.length; j++) {
            const attrId = attrIds[j];
            if(attrId == '__recordId'){
              rowMetaMap[attrId] = rowData[attrId]
              continue
            }
            if(rowData[attrId].type == 'attribute'){
              let newWidget = WidgetManager.getWidget(rowData[attrId]?.widgetType || 'label')
              let widgetProto = this.panelMeta?.listWidgetSet?.[attrId] || newWidget
              if (widgetProto) {
                Object.keys(widgetProto).forEach(prop => {
                  if(prop !== 'id') {
                    newWidget[prop] = JSON.parse(JSON.stringify(widgetProto[prop]))
                  }
                })
              }
              newWidget = this.prepareWidget(newWidget, rowData, attrId)
              rowMetaMap[attrId] = newWidget

            }else if(rowData[attrId].type == 'icon'){
              let newWidget = this.pageService.createWidget(rowData[attrId].widgetType, rowData[attrId].value)
              newWidget.type !== 'image'
                ? newWidget.setValue(rowData[attrId]?.value?.toString()?.length > 50 ? rowData[attrId]?.value?.toString()?.slice(0, 50) + '...' : rowData[attrId]?.value?.toString() || '')
                : newWidget.setValue(rowData[attrId]?.value?.toString() || '')
                rowMetaMap[attrId] = newWidget
              console.log("icon created", rowMetaMap[attrId])
            }
          }
          this.widgetMetaMap[groupVal][i] = rowMetaMap
        }
      }
    }

    // console.log("viewType", this.getCurrentViewType())
    console.log("widget meta map created", JSON.parse(JSON.stringify(this.widgetMetaMap || {})))
    // console.log("attributeIds", this.attributeIds)
    this.ready = true
    // this.cdr.detectChanges()
  }


  prepareWidget(newWidget: any, rowData: any, attrId: string) {
    let injectionValue = rowData[attrId]?.['value']
    if(newWidget.type == 'label') {
      if(!newWidget.config.tooltip) {
        let labelWid = WidgetManager.getWidget('label')
        newWidget.config.props.push('tooltip')
        newWidget.config.tooltip = JSON.parse(JSON.stringify(labelWid.config.tooltip))
      }
      if(typeof injectionValue == 'string' && injectionValue?.length > 500){
        newWidget.config.tooltip.value =  injectionValue?.substring(0, 500)
      }else if(typeof injectionValue == 'string' && injectionValue?.length <= 15){
        newWidget.config.tooltip.value = ''
      } else {
        newWidget.config.tooltip.value = injectionValue
      }
      if(injectionValue?.length && injectionValue?.length >= 500) injectionValue += '...'
    }

    // if(newWidget.type == 'tags'){
    if(['tags','chips'].includes(newWidget.type)){
      if(!injectionValue) injectionValue = [];
    }
    // console.log("will set value", JSON.parse(JSON.stringify(rowData[attrId]?.value || "")))

    // SET THE VALUE INTO WIDGET
    if (newWidget.type == 'image'){
      // newWidget.setValue(rowData[attrId]?.value?.toString() || newWidget.config.value.resetValue || '')
      this.widgetSetValue(newWidget, injectionValue?.toString() || newWidget.config.value.resetValue || '')
    // } else if (newWidget.type == 'tags') {
    } else if(['tags','chips'].includes(newWidget.type)){
      // newWidget.setValue(rowData[attrId]?.value)
      this.widgetSetValue(newWidget, injectionValue)
    } else {
      if (injectionValue?.toString()?.length > 50){
        // newWidget.setValue(rowData[attrId]?.value?.toString()?.slice(0, 50) + '...')
        this.widgetSetValue(newWidget, injectionValue?.toString()?.slice(0, 50) + '...')
      } else {
        // newWidget.setValue(rowData[attrId]?.value?.toString() || '')
        this.widgetSetValue(newWidget, injectionValue?.toString() || '')
      }
    }


    // CONFIGURE OTHER PROPERTIES OF WIDGETS

    if(newWidget.type == 'link'){
      newWidget['config']['tooltip']['value'] = rowData[attrId]?.value || "";

      newWidget['config']['linkText']['value'] = "Click to navigate";
      console.log("link widget created", newWidget)
    }
    // console.log("rowMetaMap", rowMetaMap)
    if(newWidget.type == 'datetime' || newWidget.type == 'date'){
      if(newWidget['config']['viewOnly']){
        newWidget['config']['viewOnly']['value'] = true;
      }else{
        let wid = WidgetManager.getWidget(newWidget.type)
        newWidget.config.props.push('viewOnly')
        newWidget['config']['viewOnly'] = wid.config.viewOnly
        newWidget['config']['viewOnly']['value'] = true;
      }
      // console.log(rowMetaMap[attrId]['config']['viewOnly'])
      newWidget.config.placeholder.value = '';
      if(!rowData[attrId].value) rowData[attrId].value = null;
    }

    if(newWidget.type == 'checkbox'){
      newWidget['config']['title']['show'] = false;
      newWidget['config']['value']['value'] = [''];
      newWidget['config']['availableOptions']['staticOptions'] = [{
        name: '',
        value: '',
        default: false,
        type: 'static'
      }];
    }

    if(newWidget.type == 'tags'){
      newWidget['config']['tagType']['value'] = "Stroked";
    }

    if(newWidget.type == 'chips'){
      if(newWidget['config']['viewOnly']){
        newWidget['config']['viewOnly']['value'] = true;
      }else{
        let wid = WidgetManager.getWidget('chips')
        newWidget.config.props.push('viewOnly')
        newWidget['config']['viewOnly'] = wid.config.viewOnly
        newWidget['config']['viewOnly']['value'] = true;
      }
      if (this.panelMeta?.inlineEditEnabled || newWidget?.inlineEditEnabled) {
        newWidget['config']['viewOnly']['value'] = true;
        newWidget['config']['viewOnly']['hidden'] = true;
      } else {
        newWidget['config']['viewOnly']['value'] = true
      }
      newWidget['config']['title']['value'] = ''
      if(newWidget?.config?.csvMode) newWidget.config.csvMode.value = true;
      console.log("Chips widget created", JSON.parse(JSON.stringify(newWidget)))
    }

    if(!rowData[attrId]?.value && !['image', 'checkbox'].includes(rowData[attrId]?.widgetType)){
      newWidget?.setValue('${reset}')
    }


    if(newWidget.type == 'icon'){
      // console.log("rowMetaMap", JSON.parse(JSON.stringify(rowMetaMap)))
      let attr = this.panelMeta.listAttributes.filter(attr => attr.isColumnSelected).find(a => a.__id == attrId)
      // console.log("attr", attr, "rowData", rowData)
      if (attr['conditionalConfig']?.enabled) {
      newWidget['config']['conditionalConfig'] = attr['conditionalConfig']
      } else {
        newWidget['config']['tooltip']['value'] = rowData[attrId]?.columnName || "";
      }

      if (!newWidget?.['config']?.['alignment']) {
        console.log("inside if", newWidget)
        let newWid = WidgetManager.getWidget('icon')
        newWidget['config']['props'].push('alignment')
        newWidget['config']['alignment'] = newWid['config']['alignment']
      }
      newWidget['config']['alignment']['value'] = 'start'
      // console.log("icon widget ammended", rowMetaMap[attrId])
    }

    if(newWidget.type == 'autocomplete'){
      console.log("AC widget created", JSON.parse(JSON.stringify(newWidget)))
      if (this.panelMeta?.inlineEditEnabled || newWidget?.inlineEditEnabled) {
        newWidget['config']['viewOnly']['value'] = true;
        newWidget['config']['viewOnly']['hidden'] = true;
      } else {
        newWidget['config']['viewOnly']['value'] = true
      }
      newWidget['config']['title']['value'] = ''
    }

    if(newWidget.type == 'select'){
      console.log("select widget created", JSON.parse(JSON.stringify(newWidget)))
      if (this.panelMeta?.inlineEditEnabled || newWidget?.inlineEditEnabled) {
        newWidget['config']['viewOnly']['value'] = true;
        newWidget['config']['viewOnly']['hidden'] = true;
      } else {
        newWidget['config']['viewOnly']['value'] = true
      }
      newWidget['config']['title']['value'] = ''
    }

    if(newWidget.type == 'input' || newWidget.type == "numberinput"){
      if (this.panelMeta?.inlineEditEnabled || newWidget?.inlineEditEnabled) {
        newWidget['config']['viewOnly']['value'] = true;
        newWidget['config']['viewOnly']['hidden'] = true;
      } else {
        newWidget['config']['viewOnly']['value'] = true;
      }
      newWidget['config']['title']['value'] = ''
    }
    

    return newWidget
  }


  onEditRecord(rowIndex: number, attrId: string, event: Event) {
    // Stop event propagation to prevent triggering parent click events
    event.stopPropagation();
    console.log('Editing record:', {
      rowIndex: rowIndex,
      attributeId: attrId
    });
    this.widgetMetaMap[rowIndex][attrId].config.viewOnly.value = !this.widgetMetaMap[rowIndex][attrId]?.config?.viewOnly?.value
  }

  widgetSetValue(widget: any, value: any, panelId?: string) {
    // console.log("setting value in widget", widget, "value", value)
    // this.widgetService.asyncSetValue(widget, value, panelId)
    if(widget?.type == 'chips' && value.length && typeof value == 'string'){
      let array = []
      value.split(',')?.forEach(val => {
        array.push(val)
      })
      value = array
    }
    widget.setValue(value)
    setTimeout(() => {
      this.pageService.setValueNotifier.next(widget)
    }, 1);
  }

  getWidgetType(attrId){
    let parts = attrId.split('.')
    if(parts.length > 1) {  // means composite attribute id: <attrid>.<path>, drill down exists
      let attrId = parts[0]
      let path = parts.slice(1).join('.')
      let attr = this.panelMeta.listAttributes.find(a => a.__id == attrId)
      if(!attr || !attr.isDrillDown || !attr.nestedProperties.length) return
      return attr.nestedProperties.find(np => np.path == path)?.widgetType
    }else{  // no drill down
      return this.panelMeta.listAttributes.find(a => a.__id == attrId)?.widgetType
    }
  }

  /**
   * ONLY APPLICABLE FOR BOARD VIEW
   * @param rowData
   * @returns
   */
  recreateRowMetaMap(rowData: any){
    let rowMetaMap = {}

    let attrIds = Object.keys(rowData)
    for (let j = 0; j < attrIds.length; j++) {
      const attrId = attrIds[j];
      if(attrId == '__recordId'){
        rowMetaMap[attrId] = rowData[attrId]
      }
      if(rowData[attrId].type == 'attribute'){
        rowMetaMap[attrId] = this.pageService.createWidget(rowData[attrId].widgetType, rowData[attrId].value)
      }
    }
    return rowMetaMap
  }

  /**
 * ONLY APPLICABLE FOR BOARD VIEW
 * @param tableData
 * @param panelMeta
 * @returns
 */
  groupDataForBoard(tableData, panelMeta){
    // console.log("boardStatusColumn", panelMeta.viewTypes.boardStatusColumn)
    // console.log("currentViewType", this.currentViewType)
    // console.log("panelMeta", panelMeta)
    // console.log("tableData", tableData)
    if(!panelMeta?.viewTypes){
      return tableData
    }
    if(!tableData?.length) return []
    if(panelMeta.viewTypes.defaultView !== 'board' && this.currentViewType !== 'board'){
      return tableData
    }
    console.log("will group")
    this.groupedData = {
      groupValues: []
    }
    let groupAttrId = panelMeta.viewTypes.boardStatusColumn.__id
    for (let i = 0; i < tableData?.length; i++) {
      const row = tableData[i];

      let rowGroupValue = row[groupAttrId] ? row[groupAttrId].value : ''
      if(row[groupAttrId] && rowGroupValue){
        if(this.groupedData.groupValues.findIndex(v => v == rowGroupValue) == -1){
          this.groupedData.groupValues.push(rowGroupValue)
          this.groupedData[rowGroupValue] = []
        }
        this.groupedData[rowGroupValue].push(row)
        // console.log("after push", this.groupedData)
      }else if(row[groupAttrId] && !row[groupAttrId].value){
        if(this.groupedData.groupValues.findIndex(v => v == '_ungrouped') == -1){
          this.groupedData.groupValues.push('_ungrouped')
          this.groupedData['_ungrouped'] = []
        }
        this.groupedData['_ungrouped'].push(row)
      }
    }
    console.log("grouped data ------>", this.groupedData)
  }

  /**
   * ONLY APPLICABLE FOR BOARD VIEW
   * @param event
   * @returns
   */
  async drop(event: CdkDragDrop<string[]>) {
    if(!event.item.data.__recordId){
      console.log("unique id not present, can not update")
      this._snackBar.open("unique id not present, can not update", "",  {duration: 2000});
      return
    }

    // console.log("widgetMetaMap:", this.widgetMetaMap)
    console.log("item moved", event)
    let sourceGroupVal = event.previousContainer.id
    let targetGroupVal = event.container.id
    let sourceIndex = event.previousIndex
    let targetIndex = event.currentIndex

    // shift elements in widgetMetaMap
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }

    // shift elements in groupedData
    if (sourceGroupVal === targetGroupVal) {
      moveItemInArray(this.groupedData[sourceGroupVal], event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        this.groupedData[sourceGroupVal],
        this.groupedData[targetGroupVal],
        event.previousIndex,
        event.currentIndex,
      );
    }

    let recordId = event.item.data.__recordId
    let field = this.panelMeta.viewTypes.boardStatusColumn.__id
    console.log("find __recordId", event.item.data.__recordId, "in tableData")
    console.log("change value of", this.panelMeta.viewTypes.boardStatusColumn, "from", sourceGroupVal, "to", targetGroupVal)
    console.log("groupedData", this.groupedData)

    console.log("rawBoxData", this.rawBoxData)
    console.log("primaryAttributeId", this.panelMeta.primaryAttribute)
    let primaryAttributeId = this.panelMeta.primaryAttribute.__id

    let updatedRecord
    let index: number
    for (let i = 0; i < this.tableData.length; i++) {
      if(this.tableData[i].__recordId == recordId){
        index = i
        this.tableData[i][field]['value'] = targetGroupVal
        updatedRecord = this.tableData[i][field]
      }
    }
    console.log("changed tableData", this.tableData)

    // check if update possible
    let isUpdateFnFound: boolean
    isUpdateFnFound = await this.boxService.getUpdateFuntion(this.panelMeta.connectionId, this.panelMeta.boxId, this.panelMeta.boxObjectId)
    console.log("update fn true", isUpdateFnFound)

    console.log("update fn true check outside", isUpdateFnFound)
    if(!isUpdateFnFound){
      this._snackBar.open("VALUE CHANGE NOT SUPPORTED", "",  {duration: 2000});
      return
    }

    // find and update raw box data for backend update
    let updateIndex
    for (let i = 0; i < this.rawBoxData.length; i++) {
      const record = this.rawBoxData[i];
      if(record[primaryAttributeId] == event.item.data.__recordId){
        this.rawBoxData[i][field] = targetGroupVal
        updateIndex = i
        console.log("value updated in raw data", record)
      }
    }

    // fire update request to backend
    let updateRes: any
    (async () => {
      updateRes = await this.boxService.updateRecord(this.panelMeta.connectionId, this.panelMeta.boxId, this.panelMeta.boxObjectId, this.rawBoxData[updateIndex])
    })()

    let newMetaMap = this.recreateRowMetaMap(this.tableData[index])
    console.log("newMetaMap", newMetaMap)

    this.widgetMetaMap[targetGroupVal][event.currentIndex] = newMetaMap
  }

  /**
   *
   * @param attrId
   * @param type: '+' | '-'
   * @returns
   */
  resizeImage(attrId: string, type: any){
    if(!this.builderMode) return
    // console.log("zoom in for attr:", attrId, "type:", type)
    // console.log('list attributes', this.panelMeta.listAttributes)
    let attr = this.panelMeta.listAttributes.find(attr => attr.__id == attrId)
    let oldDimension = parseInt(attr.imageDimension)
    // console.log('old dimension', oldDimension)
    let newDimension: number
    if(type == '+'){
      // console.log('entered add block')
      newDimension = oldDimension + this.imageResizeStep
    }else if(type == '-'){
      // console.log('entered minus block')
      newDimension = oldDimension - this.imageResizeStep
    }else{
      return
    }
    // console.log('new Dimension', newDimension)
    // if(this.imageWidgetWrap[0].nativeElement.clientWidth >= this.dataCard[0].nativeElement.clientWidth){
    //   return
    // }

    if(type == '+' && newDimension && newDimension > this.MAX_IMAGE_SIZE){
      console.log('cant increase more')
      return
    }
    if(type == '-' && newDimension && newDimension < this.MIN_IMAGE_SIZE){
      console.log('cant decrease more')
      return
    }

    // console.log('will assign new dimension', newDimension)
    this.tableData.forEach(rowData => {
      // console.log('adding to ', rowData)
      if(rowData[attrId] && rowData[attrId]['styles']){
        // console.log('addition valid for attrId', attrId)
        let styles: any = {
          'height': newDimension + 'rem',
          'width': newDimension + 'rem'
        }
        rowData[attrId]['styles'] = styles
      }
    })

    console.log('updated local styles in tableData')
    // update and raise updated panelMeta
    this.panelMeta.listAttributes.find(attr => attr.__id == attrId).imageDimension = newDimension
    this.metaChange.next(this.panelMeta)
  }

  /**
   *
   * @param newProto : is the new widget meta
   * @param attrId attribute id whose widget prototype needs to be changed
   */
  updateWidgetPrototype(_newProto: any, attrId: any){
    let newProto = this.wmtService.decompressWidgetMeta(_newProto) 
    let oldProto = this.panelMeta.listWidgetSet[attrId]
    // console.log("old proto", JSON.parse(JSON.stringify(oldProto)))
    if(!oldProto) {
      console.log("no old proto")
      return
    }

    // only update if text formatting changed or alignment changed
    if(JSON.stringify(oldProto.textFormat) !== JSON.stringify(newProto.textFormat)){
      console.log("text styling changed", newProto.textFormat)
      this.panelMeta.listWidgetSet[attrId]['textFormat'] = newProto.textFormat
      // this.panelMeta.listWidgetSet[attrId].generateStyles()

    }else if(oldProto.config?.alignment && (oldProto.config.alignment?.value !== newProto.config.alignment?.value)){
      console.log("alignment changed", newProto.config.alignment.value)
      this.panelMeta.listWidgetSet[attrId].config.alignment.value = newProto.config.alignment.value

    }else if (oldProto.type == 'image' && oldProto.config.width.value !== newProto.config.width.value){
      console.log("image width changed", newProto.config.width)
      this.panelMeta.listWidgetSet[attrId].config.width.value = newProto.config.width.value

    }else if (oldProto.type == 'image' && oldProto.config.imageAlignment.value !== newProto.config.imageAlignment.value){
      console.log("image alignment changed", newProto.config.imageAlignment)
      this.panelMeta.listWidgetSet[attrId].config.imageAlignment.value = newProto.config.imageAlignment.value

    }else if (oldProto.type == 'image' && oldProto.config.borderRadius.value !== newProto.config.borderRadius.value){
      console.log("image borderRadius changed", newProto.config.borderRadius)
      this.panelMeta.listWidgetSet[attrId].config.borderRadius.value = newProto.config.borderRadius.value

    }else if(oldProto.config.backgroundColor.value != newProto.config.backgroundColor.value){
      console.log("background color changed", newProto.config.backgroundColor)
      this.panelMeta.listWidgetSet[attrId].config.backgroundColor.value = newProto.config.backgroundColor.value

    }else{
      // when property to be updated is unknown, update the entire config object
      this.panelMeta.listWidgetSet[attrId].config = newProto.config
    }
    // console.log("widget prototype changed for ", attrId, " current proto", JSON.parse(JSON.stringify(this.panelMeta.listWidgetSet[attrId])))
    
    if (this.currentViewType == 'board') {
      // console.log("widgetMetaMap", JSON.parse(JSON.stringify(this.widgetMetaMap)))
      this.widgetMetaMap.groupValues.forEach((groupVal, i) => {
        let pillarMap = this.widgetMetaMap[groupVal]
        // console.log("pillarMap", JSON.parse(JSON.stringify(pillarMap)))

        pillarMap.forEach((rowMap, i) => {
          let widget = rowMap[attrId] // pick only the widget for this attribute
          // if (widget.id !== newProto.id) return
          // console.log("widget", JSON.parse(JSON.stringify(widget)))
          // update all style properties from new prototype into the existing widget, without changing the widget's value
          if ( widget.textFormat ) widget['textFormat'] = newProto.textFormat
          widget.config.props.forEach(prop => {
            // avoid replacing value property or custom value property if specified in the widget
            let wid = WidgetManager.getWidget(widget.type, widget.id, widget.name)
            let valuePath = wid.getWidgetConfig()?.valuePath
            let customValProp = valuePath?.split('.')?.[valuePath.split('.').length - 2]
            
            if ( prop !== 'value' && prop !== customValProp && widget.config[prop] && newProto.config[prop]) {
              widget.config[prop].value = newProto.config[prop].value
            }
              
          })
          console.log("widget updated ===> ", JSON.parse(JSON.stringify(widget)))
          let contextAction = {
            widgetId: widget.id,
            actionType: "updateStyles",
            data: widget,
            noEmit: true  // this flag ensures style changes reach the widget, takes effect, but the widgets do NOT emit through newWidgetMeta
          }
          this.metaService.setContextChanged(contextAction)
        })
      })
    } else {
      console.log("widgetMetaMap", JSON.parse(JSON.stringify(this.widgetMetaMap)))
      this.widgetMetaMap.forEach((rowMap, i) => {
        let widget = rowMap[attrId] // pick only the widget for this attribute
        console.log("widget", JSON.parse(JSON.stringify(widget)))
  
        // update all style properties from new prototype into the existing widget, without changing the widget's value
        if ( widget.textFormat ) widget['textFormat'] = newProto.textFormat
        Object.keys(widget.config).forEach(prop => {
          // avoid replacing value property or custom value property if specified in the widget
          let wid = WidgetManager.getWidget(widget.type, widget.id, widget.name)
          let valuePath = wid.getWidgetConfig()?.valuePath
          let customValProp = valuePath?.split('.')?.[valuePath.split('.').length - 2]
          console.log("widget", widget, "newProto", newProto)
          if ( prop !== 'value' && prop !== customValProp && widget.config[prop] && newProto.config[prop])
            widget.config[prop].value = newProto.config[prop].value
        })
        // if ( widget.config.alignment ) widget.config.alignment.value = newProto.config.alignment.value
        // if ( widget.type == 'image' ) {
        //   widget.config.width.value = newProto.config.width.value
        //   widget.config.imageAlignment.value = newProto.config.imageAlignment.value
        // }
        // if ( widget.config.backgroundColor ) widget.config.backgroundColor.value = newProto.config.backgroundColor.value
  
        // prepare context actions for the widget and make use of contextChanged observable
        let contextAction = {
          widgetId: widget.id,
          actionType: "updateStyles",
          data: widget,
          noEmit: true  // this flag ensures style changes reach the widget, takes effect, but the widgets do NOT emit through newWidgetMeta
        }
        this.metaService.setContextChanged(contextAction)
      })
    }
    this.metaChange.emit(this.panelMeta)
    // this.createWidgetMetaMap(this.currentViewType)
  }

  /**
   * triggered when mouseenter on an element.
   * sets the tooltip text if needed
   */
  setFullText(labelWrap: any, data: any){
    let target = labelWrap.srcElement.firstChild
    this.mouseOverFullText = ""
    if(target.scrollWidth > target.offsetWidth || data?.value?.length > 50) this.mouseOverFullText = data?.value
    // console.log("text set", this.mouseOverFullText)
  }

  getCardWidth(){
    let cardSize = this.panelMeta.viewTypes?.card?.cardSize || "large" //"medium"  small | medium(default) | large
    if (this.screenWidth < 600) { // xs
      return this.cardSizeMap['xs'][cardSize]
    } else if (this.screenWidth >= 600 && this.screenWidth < 900) { // sm
      return this.cardSizeMap['sm'][cardSize]
    } else if (this.screenWidth >= 900 && this.screenWidth < 1200) { // md
      return this.cardSizeMap['md'][cardSize]
    } else if (this.screenWidth >= 1200 && this.screenWidth < 1536) { // lg
      return this.cardSizeMap['lg'][cardSize]
    } else {  // xl
      return this.cardSizeMap['xl'][cardSize]
    }
  }

  //With trackByFn, Angular only updates changed elements
  trackByFnTable(index, item){
    return item ?? index;
  }

  trackByFnTableRow(index, item){
    return item ?? index;
  }

  trackByFnTableAttri(index, item){
    return item ?? index;
  }

  trackByFn(index, item) {
    return item ?? index;;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete(); // Ensures cleanup
  }

  openSnackBar(snackBarObj: any, error: any){
    this._snackBar.openFromComponent(SnackbarComponent, {
      data: {
        title: error?.error?.error?.name || error.message || error || '',
        description: error?.error?.error?.message || error?.error?.error || error?.error?.message || '',
        recommendation: snackBarObj?.snackBarRecommendation || '',
        message: snackBarObj.snackBarMessage,
        iconname: snackBarObj.snackBarIcon,
        isError: true
      },
      duration: snackBarObj.snackBarDuration || undefined,
      horizontalPosition: 'end',
    });
  }

}


/**
 * ---------------- navigate confirmation dialog for builderMode
 */
@Component({
    selector: 'navigateConfirmation',
    template: `
    <div>Navigation enabled for this field.</div>
    <div style="font-size: 1.2rem"> Test navigation?</div>
    <div style="height: 1rem"></div>
    <div mat-dialog-actions align="end">
      <button mat-stroked-button [mat-dialog-close]="false">Later</button>
      <button mat-stroked-button [mat-dialog-close]="true">Navigate and Test</button>
    </div>
  `,
    standalone: false
})
export class NavigateConfirmationComponent {
  constructor(
    public dialogRef: MatDialogRef<NavigateConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
